//#region Old Code

// import React from 'react';
// import SortTable from '../SortTable';
// import ListResults from '../ListResults';
// import shallowequal from 'shallowequal';
// import Icon from '../Icon';
// import {Link} from 'react-router';
// import svgEdit from '../../svgs/edit.svg';
// import filter from "../../filter";
// import {executeQuery} from "../../requests/executeQuery";
// import {AGENTS_LIST, AGENTS_LIST_COUNT} from '../../consts/queries';
// import LinkComp from "../LinkComp";
// import plus from "../../svgs/plus-white.svg";

// const limit = 50;

// export default class AgentList extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             items: null,
//             totalCount: null,
//             error: null,
//             isBusy: null,
//         };
//     }

//     componentDidMount() {
//         this.fetch(this.props.location.query);
//     }

//     fetch(q) {
//         this.setState({isBusy: true});

//         const query = {...q};
//         const options = filter(query, 'agents');
//         options.param.limit = limit;
//         options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

//         Promise.all([
//             executeQuery({queryName: AGENTS_LIST, options: options}),
//             executeQuery({queryName: AGENTS_LIST_COUNT, options: options})
//         ]).then(res => {
//             this.setState({
//                 items: res[0].data,
//                 totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
//                 error: res[0].success ? null : res[0].message,
//                 isBusy: null,
//             });
//         });
//     }

//     componentDidUpdate(prevProps) {
//         if (!shallowequal(prevProps.location.query, this.props.location.query)) {
//             this.fetch(this.props.location.query);
//         }
//     }

//     render() {
//         const query = this.props.location.query;

//         const columns = [
//             {
//                 name: 'View',
//                 textAlign: 'center',
//                 columnStyle: {width: 70},
//                 render: (el) => (
//                     <Link to={{pathname: `${arc.path.base}agent/${el.ARCIMEDES_ROW_ID}`}}><Icon svg={svgEdit}/></Link>
//                 ),
//             },
//             {
//                 code: 'FIRST_NAME',
//                 name: 'First Name',
//                 render: (el) => el.FIRST_NAME,
//             },
//             {
//                 code: 'LAST_NAME',
//                 name: 'Last Name',
//                 render: (el) => el.LAST_NAME,
//             },
//             {
//                 code: 'EMAIL',
//                 name: 'Email',
//                 render: (el) => el.EMAIL ? <a href={`mailto:${el.EMAIL}`}>{el.EMAIL}</a> : null,
//             },
//             {
//                 code: 'PHONE',
//                 name: 'Work Phone',
//                 render: (el) => el.PHONE ?
//                     <a href={`tel:${el.PHONE.replace(' ', '-').replace('/[()]/g', '')}`}>{el.PHONE}</a> : null,
//             },
//             {
//                 code: 'CELL_PHONE',
//                 name: 'Cell Phone',
//                 render: (el) => el.CELL_PHONE ?
//                     <a href={`tel:${el.CELL_PHONE.replace(' ', '-').replace('/[()]/g', '')}`}>{el.CELL_PHONE}</a> : null,
//             },
//             {
//                 code: 'NAME',
//                 name: 'Firm',
//                 render: (el) => el.NAME,
//             },
//         ];

//         return (
//             <div className='AgentList' data-is-busy={this.state.isBusy}>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container list'>
//                         <div className='page-header list'>
//                             <div className='page-title'>Agents</div>
//                             <LinkComp to={`${arc.path.base}agent`}>
//                                 <div className="button-new plus positive">
//                                     <Icon svg={plus}/>
//                                 </div>
//                             </LinkComp>
//                         </div>
//                         <div className='line'/>
//                     </div>
//                 </div>
//                 <div className='page-body-container'>
//                     <SortTable columns={columns}
//                                items={this.state.items}
//                                query={query}
//                     />
//                     <ListResults query={this.props.location.query}
//                                  pathname={this.props.location.pathname}
//                                  error={this.state.error}
//                                  totalCount={this.state.totalCount}
//                                  itemCount={this.state.items ? this.state.items.length : false}
//                                  limit={limit}
//                     />
//                 </div>
//             </div>
//         );
//     }
// }

//#endregion

import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import { Link } from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import filter from "../../filter";
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import { ApolloConsumer } from '@apollo/client';
import { GET_AGENTS, GET_AGENTS_WTH_FILTERS } from '../Graphql/queries';
import { GET_CONTACT_AGENTS_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import { fetchData } from '../Service/graphQlService';
const limit = 50;
export default class AgentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: null,
            totalCount: null,
            error: null,
            isBusy: null,
        };
        this.client = null
    }

    componentDidMount() {
        if (this.client) {
            this.fetch(this.props.location.query);
        }
    }

    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field.toLowerCase() === "name" ? "firm": field.toLowerCase(),
                    order: order.toLowerCase()
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field.toLowerCase() === "name" ? "firm": field.toLowerCase(),
                order: order.toLowerCase()
            }];
        }
        else{
            return [];
        }

    }

    parseFilterOptions(query){
        const filterObject = {};
        if(query){
            for(const key in query){
                if(key !== 'order' && key !== 'page'){
                    filterObject[key]= query[key]
                }
            }
        }
        return [filterObject]
    }

    fetch(q) {
        this.setState({ isBusy: true });
        const query = { ...q };
        const options = filter(query, 'agents');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;
        var pageParams = {
            page: query.page ? Number(query.page) : 1,
            pageSize: limit
        }
        const token = localStorage.getItem('authToken');
        
        const sortOptions = this.parseSortOptions(q.order);
        const filterOptions = this.parseFilterOptions(q); 

        if (this.client && token) {
           // this.client.query({
            //     query: GET_AGENTS_WTH_FILTERS, variables: { pageOptions: pageParams,filters:filterOptions, sortOptions: sortOptions }, fetchPolicy: "no-cache",
            //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     },
            // })
            fetchData(GET_CONTACT_AGENTS_LIST_QUERY, { type: "Agent",pageOptions: pageParams,filters:filterOptions, sortOptions: sortOptions })
                .then(res => {
                    this.setState({
                        items: res.data.getContacts.data,
                        totalCount: res.data.getContacts.totalCount,
                        error: null,
                        isBusy: null,
                    });
                })
                .catch(err => {
                    this.setState({
                        error: err.message,
                        isBusy: null,
                    });
                });
    }
    }
    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    render() {
        const query = this.props.location.query;
        const itemsToDisplay = this.state.items ? this.state.items.slice(0, 50) : [];
        const columns = [
            {
                name: 'View',
                textAlign: 'center',
                columnStyle: { width: 70 },
                // render: (el) => (
                //     <Link to={{ pathname: `${arc.path.base}agent/${el.contact_id}` }}><Icon svg={svgEdit} /></Link>
                // ),
                render: (el) => {
					const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
					const currentSearch = window.location.search;
					const currentPath = window.location.pathname + currentSearch;
				  
					return (
					  <Link to={{
						pathname: `${basePath}/agent/${el.contact_id}`,
						state: { fromListUrl: currentPath }
					  }}>
						<Icon svg={svgEdit} />
					  </Link>
					);
				  }
            },
            {
                code: 'FIRST_NAME',
                name: 'First Name',
                render: (el) => el.first_name,
            },
            {
                code: 'LAST_NAME',
                name: 'Last Name',
                render: (el) => el.last_name,
            },
            {
                code: 'EMAIL',
                name: 'Email',
                render: (el) => el.email ? <a href={`mailto:${el.email}`}>{el.email}</a> : null,
            },
            {
                code: 'PHONE',
                name: 'Work Phone',
                render: (el) => el.phone ?
                    <a href={`tel:${el.phone.replace(' ', '-').replace('/[()]/g', '')}`}>{el.phone}</a> : null,
            },
            {
                code: 'CELL_PHONE',
                name: 'Cell Phone',
                render: (el) => el.cell_phone ?
                    <a href={`tel:${el.cell_phone.replace(' ', '-').replace('/[()]/g', '')}`}>{el.cell_phone}</a> : null,
            },
            {
                code: 'NAME',
                name: 'Company',
                render: (el) => el.firm ? el.firm : null,
            },
            {
				code: 'ADDRESS',
				name: 'Address',
				render: (el) => el.address,
			},
			{
				code: 'CITY',
				name: 'City',
				render: (el) => el.city,
			},
			{
				code: 'STATE',
				name: 'State',
				render: (el) => el.state,
			},
            {
				code: 'ZIP',
				name: 'Zip',
				render: (el) => el.zip,
			}
        ];

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                        // this.fetch(this.props.location.query);
                    }
                    return (
                        <div className='AgentList' data-is-busy={this.state.isBusy}>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container list'>
                                    <div className='page-header list'>
                                        <div className='page-title'>Agents</div>
                                        <LinkComp
                                            to={{
                                                pathname: `${arc.path.base}agent`,
                                                state: { fromListUrl: window.location.pathname + window.location.search }
                                            }}
                                        >
                                            <div className="button-new plus positive">
                                                <Icon svg={plus} />
                                            </div>
                                        </LinkComp>
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container'>
                                <SortTable columns={columns}
                                    items={itemsToDisplay}
                                    query={query}
                                />
                                <ListResults query={this.props.location.query}
                                    pathname={this.props.location.pathname}
                                    error={this.state.error}
                                    totalCount={this.state.totalCount}
                                    itemCount={itemsToDisplay.length}
                                    limit={limit}
                                />
                            </div>
                        </div>
                    )
                }}

            </ApolloConsumer>
        );
    }
}
